import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  accountUsersProviderSlice,
  userLoginProviderSlice,
} from '@nucleus-care/react-native-nucleuscare-connect-security-client';
import localDataSlice from './slices/localDataSlice';
import accountCustomLinkButtonSlice from './slices/accountCustomLinkButtonSlice';
import accountCustomSchedulingButtonSlice from './slices/accountSchedulingButtonSlice';
import accountClassSessionConfigSlice from './slices/accountClassSessionConfigSlice';
import accountExternalAppsSlice from './slices/accountExternalAppsSlice';
import accountIntegrationConfigSlice from './slices/accountIntegrationConfigSlice';
import familySlice from './slices/familySlice';
import userConfigSlice from './slices/userConfig';
import loggedInUserConfigSlice from './slices/loggedInUserConfig'
import classSessionSlice from './slices/classSessionSlice';
import classSessionUser from './slices/classSessionUser';
import classSessionPatient from './slices/classSessionPatient';
import userSlice from './slices/userSlice';
import csReportsSlice from './slices/csReports';
import csUsersSlice from './slices/csUsers';
import callSlice from './slices/callSlice';
import csDevicesSlice from './slices/csDevices';
import consumerSlice from './slices/consumer';
import patientBulletinSlice from './slices/patientBulletin';
import reportsSlice from './slices/reports';
import mdmPolicySlice from './slices/mdmPolicy';
import mdmAccountsSlice from './slices/mdmAccounts';
import mdmPolicyTemplatesSlice from './slices/mdmPolicyTemplates';
import mdmDeviceSlice from './slices/mdmDevice';

export const rootReducer = combineReducers({
  localData: localDataSlice.reducer,
  userLoggedInConfig: loggedInUserConfigSlice.reducer,
  userConfig: userConfigSlice.reducer,
  userLoginProvider: userLoginProviderSlice.reducer,
  accountUsersProviders: accountUsersProviderSlice.reducer,
  accountCustomLinkButton: accountCustomLinkButtonSlice.reducer,
  accountCustomSchedulingButton: accountCustomSchedulingButtonSlice.reducer,
  accountClassSessionConfig: accountClassSessionConfigSlice.reducer,
  accountExternalApps: accountExternalAppsSlice.reducer,
  accountIntegrationConfig: accountIntegrationConfigSlice.reducer,
  classSessionUsers: classSessionUser.reducer,
  classSession: classSessionSlice.reducer,
  classSessionPatient: classSessionPatient.reducer,
  family: familySlice.reducer,
  me: userSlice.reducer,
  call: callSlice.reducer,

  csDevicesStore: csDevicesSlice.reducer,
  csReportsStore: csReportsSlice.reducer,
  csUsersStore: csUsersSlice.reducer,
  consumerStore: consumerSlice.reducer,
  patientBulletins: patientBulletinSlice.reducer,
  reports: reportsSlice.reducer,
  mdmPolicy: mdmPolicySlice,
  mdmAccounts: mdmAccountsSlice,
  mdmPolicyTemplates: mdmPolicyTemplatesSlice,
  mdmDevice: mdmDeviceSlice
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore<RootState>({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: any) => {
    return getDefaultMiddleware({ immutableCheck: false });
  },
});
